import { useTranslation } from 'react-i18next';

import type { ForumModerator } from '~/api/forum/types';

import { Avatar, Dialog, ExternalLinkButton, Logo, Separator } from '~/components';

import {
  bodyStyle,
  brandStyle,
  contentStyle,
  creativeShelterLogoStyle,
  descriptionStyle,
  footerItemStyle,
  footerStyle,
  headerStyle,
  headerWrapperStyle,
  nameStyle,
  profilePictureStyle,
  textWrapperStyle,
} from './ModeratorProfileDialog.css';

type Props = {
  moderator: ForumModerator;
};

export const ModeratorProfileDialog = ({ moderator }: Props) => {
  const { t } = useTranslation(['community', 'forum']);

  return (
    <Dialog.Body className={bodyStyle}>
      <Dialog.Header className={headerStyle}>
        <div className={headerWrapperStyle}>
          <Avatar
            aria-label={t('community:avatar', { name: moderator.firstName })}
            className={profilePictureStyle}
            fallback={moderator.firstName.charAt(0)}
            src={moderator.profilePictureUrl ?? undefined}
          />

          <div className={textWrapperStyle}>
            <p className={nameStyle}>{moderator.firstName}</p>

            <span className={nameStyle}>·</span>

            <p className={brandStyle}>
              <Logo className={creativeShelterLogoStyle} variant="symbol" />

              {moderator.brandName}
            </p>
          </div>
        </div>
      </Dialog.Header>

      <div className={contentStyle}>
        <p className={descriptionStyle}>{t('forum:moderatorDialog.introduction', { firstName: moderator.firstName })}</p>

        <Separator aria-hidden />

        <footer className={footerStyle}>
          <ExternalLinkButton
            aria-label={t('community:profileCard.footer.mail')}
            className={footerItemStyle}
            href="mailto:community@creativeshelter.be"
            icon="Mail"
          />
        </footer>
      </div>
    </Dialog.Body>
  );
};
